(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RacerDetailController', RacerDetailController);

    RacerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Racer', 'Trainer', 'Runner', 'Schedule'];

    function RacerDetailController($scope, $rootScope, $stateParams, previousState, entity, Racer, Trainer, Runner, Schedule) {
        var vm = this;

        vm.racer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:racerUpdate', function(event, result) {
            vm.racer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
